import React, { useEffect, useState } from "react"

import {
  Form,
  Input,
  Label,
  CardTitle,
  Row,
  Col,
  FormFeedback,
} from "reactstrap"

import PanCard from "../../assets/images/icons/pan-card.svg"
import AadharCard from "../../assets/images/icons/aadhar-card.svg"
import BankDetail from "../../assets/images/icons/bank-detail.svg"
import Signature from "../../assets/images/icons/signature.svg"
import {
  useGetOtpPhoneVerificationMutation,
  useVerifyOtpPhoneVerificationMutation,
} from "store/api/kyc/kyc"
import { useFormik } from "formik"
import * as Yup from "yup"
import toast from "react-hot-toast"
import Spinners from "components/Common/Spinner"
import OTPInput from "react-otp-input"
import { useSelector } from "react-redux"

const PhoneVerification = ({ kycData, querySteps = [] }) => {
  const [sendOtp, { isLoading }] = useGetOtpPhoneVerificationMutation()
  const { user, userType } = useSelector((state) => state.user)
  const [verifyOtp, { isLoading: isVerifying }] =
    useVerifyOtpPhoneVerificationMutation()
  const [isOtp, setIsOtp] = useState(false)
  const counterTime = 60
  const [counter, setCounter] = useState(0)

  useEffect(() => {
    validation.setFieldValue("phoneNumber", kycData.phone || "")
  }, [kycData])

  const onSendOTP = async (body) => {
    try {
      const { success, message } = await sendOtp({
        phoneNumber: body["phoneNumber"].toString(),
        kycStep: kycData.status,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "verifySuccess" })
        setIsOtp(true)
        setCounter(counterTime)
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const onVerifyOTP = async (body) => {
    try {
      const { success, message } = await verifyOtp({
        otp: body["otp"].toString(),
        phoneNumber: body["phoneNumber"].toString(),
        kycStep: kycData.status,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "verifySuccess" })
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      phoneNumber: "",
      otp: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      if (!isOtp) {
        onSendOTP(values)
      } else {
        onVerifyOTP(values)
      }
    },
  })

  useEffect(() => {
    if (isOtp && counter > 0) {
      const timer = setTimeout(() => {
        setCounter(counter - 1)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [counter])

  const onResendOTP = () => {
    validation.setFieldValue("otp", "")
    onSendOTP({ ...validation.values })
  }

  return (
    <>
      <div className="">
        <h5 className="title mb-3">
          {!isOtp ? "Phone Verification" : "Verify OTP"}
        </h5>
        <Form
          onSubmit={(e) => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Row className="mb-2">
            {!isOtp ? (
              <Col xl={12}>
                <Label className="col-form-label">Phone Number</Label>
                <Input
                  name="phoneNumber"
                  type="number"
                  className="form-control"
                  id="horizontal-firstname-Input"
                  placeholder="Enter your phone number"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.phoneNumber}
                  invalid={
                    validation.touched.phoneNumber &&
                    validation.errors.phoneNumber
                  }
                />
                {validation.touched.phoneNumber &&
                validation.errors.phoneNumber ? (
                  <FormFeedback type="invalid">
                    {validation.errors.phoneNumber}
                  </FormFeedback>
                ) : null}

                <span className="floating-labels">
                  We will send an OTP to this number
                </span>
              </Col>
            ) : (
              <Col xl={12}>
                <div>
                  {/* <Label className="col-form-label">OTP</Label> */}
                  <div>
                    <Label className="form-label">OTP</Label>
                    <div className={`${validation.errors.otp && "is-invalid"}`}>
                      <OTPInput
                        onChange={(val) => {
                          validation.setFieldValue("otp", val)
                        }}
                        shouldAutoFocus
                        inputType={"number"}
                        inputStyle={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "10px",
                          border: "1px solid #ddd",
                        }}
                        containerStyle={{
                          display: "flex",
                          gap: "15px",
                        }}
                        value={validation.values.otp || ""}
                        numInputs={6}
                        renderInput={(props) => <input {...props} />}
                      />
                    </div>
                    {validation.errors.otp ? (
                      <FormFeedback type="invalid">
                        {validation.errors.otp}
                      </FormFeedback>
                    ) : null}
                  </div>

                  <div
                    className="text-start mt-2"
                    style={{
                      color: "#a9a9a9",
                    }}
                  >
                    {counter > 0 && (
                      <p style={{ textAlign: "left" }}>
                        {`Didn't receive the OTP? Resend OTP in ${counter} sec`}
                      </p>
                    )}
                    {counter <= 0 && (
                      <div
                        style={{
                          color: "#035ca1",
                          cursor: "pointer",
                        }}
                        onClick={onResendOTP}
                        // cursor={"pointer"}
                        // color={Colors.text.black}
                      >
                        {isLoading ? (
                          <Spinners
                            color="dark"
                            className="align-items-center justify-content-start"
                          />
                        ) : (
                          "Resend OTP"
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </Col>
            )}
            <Col sm={12}>
              <Row className="mt-4">
                {isOtp && (
                  <Col md="6" lg="6">
                    <button
                      type="button"
                      onClick={() => setIsOtp(false)}
                      className="btn btn-primary prev-button w-100"
                    >
                      Previous Page
                    </button>
                  </Col>
                )}
                <Col lg={!isOtp ? "12" : "6"}>
                  <button
                    type="submit"
                    className="btn btn-primary w-100"
                    disabled={isLoading || isVerifying}
                  >
                    {isLoading || isVerifying ? (
                      <Spinners />
                    ) : !isOtp ? (
                      "Save & Next"
                    ) : (
                      "Verify & Next"
                    )}
                  </button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
        {!isOtp && kycData?.status !== "QUERY_RAISED" && (
          <Row>
            <Col sm={12}>
              <div className="phone-verification-details">
                <p>
                  This phone number will be used to share your investment
                  details & other important communications
                </p>
                <div className="phone-verification">
                  <div className="card-box">
                    <img src={PanCard} alt="" />
                    <h4>PAN Card</h4>
                  </div>
                  <div className="card-box">
                    <img src={AadharCard} alt="" />
                    <h4>Aadhar Card</h4>
                  </div>
                  <div className="card-box">
                    <img src={BankDetail} alt="" />
                    <h4>Bank Details</h4>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    </>
  )
}

export default PhoneVerification
